export const REFRESH_BUFFER_MS = 2 * 60 * 1000; // 2 minutes

export enum MEDIA_TYPE {
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
}